// Core Modules
import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToastsService {
  // Public Members
  public toasts: any[] = [];

  public clear(): void {
    this.toasts.splice(0, this.toasts.length);
  }

  public remove(toast: any): void {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  public show(textOrTpl: string | TemplateRef<unknown>, options: Partial<any> = {}): void {
    this.toasts.push({ textOrTpl, ...options });
  }
}
